import { getProperties } from './getProperty'
import { getPropertySearchList } from './getPropertySearchList'

export default [
  getProperties,
  getPropertySearchList
]
